import { Avatar } from "components"
import styles from "./style/styles.module.scss"
import { loadProfileImage } from "utils/CreateProfileFromInitials"

const AvatarWithLetter = ({ userProfileImage, fullName, color, textcolor, ...props }) => {
    return (
        <Avatar className={styles.avatarImgStyleGloble} src={loadProfileImage(userProfileImage, fullName, color, 100, textcolor)}  {...props} />
    )
}
export default AvatarWithLetter
